import { useAuthStore } from '../stores';

/**
 * Get authorization headers for API requests (synchronous).
 * Prefer getValidAuthHeaders() for main-thread calls to ensure the token is fresh.
 */
export const getAuthHeaders = (): HeadersInit => {
  // Check if we're in a worker context with a token
  const workerToken = (globalThis as any).__AUTH_TOKEN__;
  if (workerToken) {
    return {
      'Authorization': `Bearer ${workerToken}`,
      'Content-Type': 'application/json',
    };
  }
  
  // Otherwise use the auth store (main thread)
  const state = useAuthStore.getState();
  
  if (state.idToken) {
    return {
      'Authorization': `Bearer ${state.idToken}`,
      'Content-Type': 'application/json',
    };
  }
  
  return {
    'Content-Type': 'application/json',
  };
};

/**
 * Get authorization headers after ensuring the token is valid (async).
 * Refreshes the token if it's expired or about to expire.
 * Use this for main-thread API calls.
 */
export const getValidAuthHeaders = async (): Promise<HeadersInit> => {
  const token = await useAuthStore.getState().ensureValidToken();
  if (token) {
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }
  return {
    'Content-Type': 'application/json',
  };
};

/**
 * Create fetch options with auth headers
 */
export const createAuthFetchOptions = (options: RequestInit = {}): RequestInit => {
  const authHeaders = getAuthHeaders();
  
  return {
    ...options,
    headers: {
      ...authHeaders,
      ...options.headers,
    },
  };
};
